import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { ConfigurationContext, ContentContext } from '../../context';
import SelectCustom from './SelectCustom';
import LoaderComponent from './LoaderComponent';
import SelectMultiCustom from './SelectMultiCustom';

import { RoleIcon, } from '../../helpers/icons';

import { getLabelName } from '../../helpers/functions';

const Wrapper = styled.div`
    width: 100%;
    .loader{
        margin-top: 15px;
        margin-left: 5px;
    }
    .box_select_multi_custom{
        width: 100%;
        .field_pos_list{
            width: 100%!important;
        }
        .box_add_labels{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            .field_labels_add{
                width: 100%;
            }
            .bt_add_label{
                margin: 15px 0;
                padding: 0;
                height: auto;
                p{
                    padding: 0;
                    margin: 0;
                }
            }
        }
        .box_labels_selected{
            display: flex;
            flex-direction: row;
            margin-top: 10px;
            flex-wrap: wrap;
            .label{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                border: 2px solid ${props => `rgb(${props.pancolors.dark_gray})`};
                border-radius: 8px;
                box-sizing: border-box;
                padding: 10px 15px;
                margin-bottom: 10px;
                margin-right: 10px;
                color: ${props => `rgb(${props.pancolors.dark_gray})`};
                font-weight: 600;
                &.exist{
                    border-color: ${props => `rgb(${props.pancolors.dots})`};
                    background-color: ${props => `rgb(${props.pancolors.dots})`};
                    color: #FFFFFF;
                }
                .close{
                    cursor: pointer;
                    :hover{
                        color: ${props => `rgb(${props.pancolors.red})`};
                    }
                }
                :first-child {
                    margin-left: 0;
                }
                p{
                    margin: 0 0 0 5px;
                }
            }
        }
    }
`

const UserPos = (props) => {

    const { userFlagError,
            userFlag, 
            setUserFlag,
            role = null } = props;

    const { panColors,
            clientData } = useContext(ConfigurationContext);
    
    const { basicData,
            posList,
            getPosToAsign} = useContext(ContentContext);

    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};

    useEffect(() => {
        
        if(posList === null){
            getPosToAsign();
        }
    
      return () => {}
    }, [posList])

    const handleRemoveLabel = (_label) => {
        
        let remove_label = [...userFlag];
        const filtered = remove_label.filter(label => label !== _label);
        setUserFlag(filtered);

    }

    const handleFormElementChange = (name, value) => {
        switch (name) {
            case 'select_flag':
                let result = userFlag.filter(e => e === value);
                if(!result.length){
                    let update = [...userFlag];
                    update.push(value);
                    setUserFlag(update);
                }
                break;
            default:
                break;
        }
        
        return null;
        
    }

    return (
        <Wrapper 
            pancolors={panColors}
        >
            {basicData?.flags ?
            <div className='box_select_multi_custom'>

                <SelectMultiCustom 
                    name={"select_flag"}
                    label={basicData.settings.users.section_fields.flag.label}
                    userPosError={userFlagError}
                    userPos={userFlag}
                    setUserPos={setUserFlag}
                    role={""}//formData?.role?.value
                    data={basicData?.flags}
                    className={`field field_pos_list${userFlagError ? " error" : ""}`}
                    onChange={handleFormElementChange}
                    disabled={false/*clientData.name_clients !== "one_sp" ? false : (role === "6494b12090c83a00089bde56" || role === "6494c5eaf8cf9900084250dd" || role === "6494c715f8cf9900084251c5") ? false : userFlag?.length ? true : false*/}
                    label_icon={<RoleIcon />}
                /> 
                
                {userFlag?.length ?
                    <div className='box_labels_selected'>
                        {userFlag?.map((label, index) => {
                            let name = '';
                            name = getLabelName(basicData.flags, label);
                            
                            return(
                                <>
                                    {name ? 
                                        <div key={`label-${index}`} className={`label`}>
                                            <div className="close" onClick={() => handleRemoveLabel(label)}>x</div>
                                            <p>{ name }</p>
                                        </div>
                                    : ""}
                                </>
                            )
                        })}
                    </div> : ""
                }

            </div>
            :
            <div className='loader'>
                <LoaderComponent size={30} color={panColors.primary} />
            </div>
            }

        </Wrapper>

    )

}

export default UserPos;